import styles from './CallBlock.module.scss';
import LinkNumbers from '../LinkNumbers/LinkNumbers';

const CallBlock = () => {
  return (
    <div
      className={styles.container}
      itemScope
      itemType='https://schema.org/ContactPoint'
    >
      <div className={styles.item}>
        <div className={styles.title}>To call Bakcell number dial</div>
        <div className={styles.numbers}>
          <LinkNumbers
            className={styles.call}
            dark
            numbers={'*135*'}
            isNotLink
          />
          <span className={styles.number}>055 XXX XX XX</span>
          <LinkNumbers
            className={styles.call}
            dark
            isNotLink
            isTel
            numbers={'#'}
          />
        </div>
      </div>

      <div className={styles.item}>
        <div className={styles.title}>
          To call other operators or city numbers in Azerbaijan dial
        </div>
        <div className={styles.numbers}>
          <LinkNumbers
            className={styles.call}
            dark
            numbers={'*135*'}
            isNotLink
          />
          <span className={styles.number}>Operator or city code</span>
          <span className={styles.number}>055 XXX XX XX</span>
          <LinkNumbers
            className={styles.call}
            dark
            isNotLink
            isTel
            numbers={'#'}
          />
        </div>
      </div>

      <div className={styles.item}>
        <div className={styles.title}>To call international numbers dial</div>
        <div className={styles.numbers}>
          <LinkNumbers
            className={styles.call}
            dark
            numbers={'*135*'}
            isNotLink
          />
          <span className={styles.number}>country code</span>
          <span className={styles.number}>operator or city code</span>
          <span className={styles.number}>055 XXX XX XX</span>
          <LinkNumbers
            className={styles.call}
            dark
            isNotLink
            isTel
            numbers={'#'}
          />
        </div>
      </div>
    </div>
  );
};

export default CallBlock;
